<template>
  <div>
    <div style="color: #cfcfcf; font-size: 13px; text-align: right">
      过去15天日均气温
    </div>
    <div id="chart-past" style="height: 160px"></div>
    <!-- <img src="./pic/left15days.png" alt="" style="width:100%;height:160px;" /> -->
  </div>
</template>
<script>
import axios from 'axios'
import Charts from '@jiaminghi/charts'
export default {
  data() {
    return {}
  },
  created() {},
  mounted() {
    setTimeout(() => {
      this.chart = new Charts(document.getElementById('chart-past'))
      const data1 = ['', '', '', '', '', '', '']
      const data2 = [21, 16, 15, 17, 15, 18, 19]
      this.drawChart(data1, data2)

      // axios
      //   .get('http://berry-internet.zkhfzhnyg.cn/api/weather/past15days-aggr')
      //   .then((resp) => {
      //     console.log('weather', resp.data)
      //     const data1 = []
      //     const data2 = []
      //     resp.data.forEach((item) => {
      //       data1.push('')
      //       data2.push(item.avg)
      //     })
      //     this.drawChart(data1, data2)
      //   })
    })
  },
  methods: {
    drawChart(data1, data2) {
      console.log('绘制折线图::', data2)
      this.chart.setOption({
        title: {
          show: false
        },
        xAxis: {
          name: '第一周',
          data: data1,
          boundaryGap: true
        },
        yAxis: {
          name: '销售额',
          data: 'value',
          splitLine: { show: false },
          axisLine: { show: false },
          axisLabel: { show: false },
          axisTick: { show: false }
        },
        series: [
          {
            data: data2,
            type: 'line',
            label: {
              show: true
            },
            lineArea: { show: true, style: { opacity: 0.3 } }
          }
        ],
        grid: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/screen28896/weather-zone/chart-past.vue